<template>
  <div
    class="sb-time-block"
    data-sb-regression="sb-vertical-timeline"
  >
    <div class="sb-time-block__times">
      <span class="sb-time-block__title">
        <!--
        @slot for the title of the timeline
        -->
        <slot name="title" />
      </span>
      <!--
      @slot for timeline content. Loops through the nodes property
      -->
      <slot
        v-for="node in nodes"
        :node="node"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SbVerticalTimeline',
  props: {
    /**
     * An array of objects to pass to the default slot
     */
    nodes: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>

<style lang="scss">
@import '@src/components/Timeline/style/sb-vertical-timeline.scss';
</style>
